import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';
import { formatViews } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'normal' | 'large';
}

export default function ComicCard({ comic, size = 'normal' }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block cursor-pointer"
    >
      <div className={`relative overflow-hidden rounded-lg bg-background-100 ${
        size === 'large' ? 'aspect-[3/4]' : 'aspect-[3/4]'
      }`}>
        <img
          src={comic.coverImage}
          alt={comic.title}
          title={`${comic.title} - 免费阅读韩国漫画`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />

        {comic.isHot && (
          <span className="absolute top-2 left-2 px-2 py-0.5 bg-accent-500 text-xs font-medium text-background-50 rounded-md">
            热门
          </span>
        )}
        {comic.isNew && (
          <span className="absolute top-2 left-2 px-2 py-0.5 bg-primary-500 text-xs font-medium text-background-50 rounded-md">
            新作
          </span>
        )}
        {comic.isCompleted && (
          <span className="absolute top-2 right-2 px-2 py-0.5 bg-foreground-700/80 text-xs font-medium text-background-50 rounded-md">
            已完结
          </span>
        )}

        <div className="absolute bottom-0 left-0 right-0 p-3">
          <h3 className="text-sm font-semibold text-background-50 line-clamp-1 group-hover:text-primary-300 transition-colors">
            {comic.title}
          </h3>
          <div className="flex items-center gap-2 mt-1">
            <span className="text-xs text-background-50/70">{comic.author}</span>
            <span className="text-xs text-accent-400">
              <i className="ri-star-fill text-[10px]"></i> {comic.rating}
            </span>
          </div>
        </div>
      </div>

      <div className="mt-2 px-1">
        <div className="flex items-center justify-between">
          <span className="text-xs text-foreground-500">{comic.category}</span>
          <span className="text-xs text-foreground-400">
            <i className="ri-eye-line text-[10px]"></i> {formatViews(comic.views)}
          </span>
        </div>
        {size === 'large' && (
          <p className="text-xs text-foreground-500 mt-1.5 line-clamp-2 leading-relaxed">
            {comic.description.slice(0, 80)}...
          </p>
        )}
      </div>
    </Link>
  );
}